import { fetchRequestWithTypes } from './index.js';

export const POST_USER_TEST_ASSIGNMENTS_REQUEST = 'POST_USER_TEST_ASSIGNMENTS_REQUEST';
export const POST_USER_TEST_ASSIGNMENTS_SUCCESS = 'POST_USER_TEST_ASSIGNMENTS_SUCCESS';
export const POST_USER_TEST_ASSIGNMENTS_ERRORED = 'POST_USER_TEST_ASSIGNMENTS_ERRORED';

export const postUserTestAssignments = (testName = 'skip-plastic-test') =>
	fetchRequestWithTypes({
		types: [
			POST_USER_TEST_ASSIGNMENTS_REQUEST,
			POST_USER_TEST_ASSIGNMENTS_SUCCESS,
			POST_USER_TEST_ASSIGNMENTS_ERRORED,
		],
		request: {
			method: 'POST',
			path: `/onboarding/api/v3/users/:uuid/tests/user_test_assignments/test_entry`,
			body: {
				userTestAssignment: {
					testName,
				},
			},
		},
	});
